import { create } from "zustand";
import axiosInstance from "../utils/axiosInstance";

export const useCategoriesStore = create((set, get) => ({
    categories: [],
    selectedCategoryId: null,
    setCategories: (categories) => set({ categories }),
    setSelectedCategoryId: (categoryId) => set({ selectedCategoryId: categoryId }),
    loading: false,
    fetchCategories: async () => {
        set({loading: true})
        try {
            const response = await axiosInstance.get('/api/categories/list')
            console.log('Categories API response:', response.data)
            set({categories: response.data.data, loading: false})
        } catch (error) {
            console.error('Error fetching categories:', error)
            set({ loading: false })
        }
    },
    // Method to clear selected category when leaving shop page
    clearSelectedCategory: () => {
        set({ selectedCategoryId: null });
    },
    // Method to handle category clicking from any component
    handleCategoryClick: (categoryId, filters, setFilters, setSelectedCategory = null, navigate = null) => {
        const currentSelectedId = get().selectedCategoryId;
        
        if (currentSelectedId === categoryId) {
            // If clicking the already selected category, unselect it
            set({ selectedCategoryId: null });
            
            // Remove category filter if setFilters is provided
            if (setFilters) {
                const newFilters = {...filters};
                delete newFilters.category;
                setFilters(newFilters);
            }
            
            // Update component state if provided
            if (setSelectedCategory) {
                setSelectedCategory(null);
            }
            
            // If on the shop page, update URL; otherwise navigate without category param
            if (navigate) {
                if (window.location.pathname === '/shop') {
                    // When on shop page, the filters-to-URL sync in ShopSection will handle this
                } else {
                    navigate('/shop');
                }
            }
        } else {
            // Select the new category
            set({ selectedCategoryId: categoryId });
            
            // Add category filter if setFilters is provided
            if (setFilters) {
                setFilters({...filters, category: categoryId});
            }
            
            // Update component state if provided
            if (setSelectedCategory) {
                setSelectedCategory(categoryId);
            }
            
            // If on shop page, update URL; otherwise navigate with category param
            if (navigate) {
                if (window.location.pathname === '/shop') {
                    // When on shop page, the filters-to-URL sync in ShopSection will handle this
                } else {
                    navigate(`/shop?category=${categoryId}`);
                }
            }
        }
    }
}))